import { Action } from '@ngrx/store';
import { IColumnDefinition } from '@common/models/column-definition';
export const LOAD_ALL = '[Arrears Transaction Table Column Definition] Load All';
export const LOAD_ALL_COMPLETE = '[Arrears Transaction Table Column Definition] Load All Complete';
export const LOAD_ALL_ERROR = '[Arrears Transaction Table Column Definition] Load All Error';

export class LoadAll implements Action {
  readonly type = LOAD_ALL;
  constructor() { }
}

export class LoadAllComplete implements Action {
  readonly type = LOAD_ALL_COMPLETE;
  constructor(public payload: IColumnDefinition[]) { }
}



export type Actions =
  LoadAll |
  LoadAllComplete

